import React, { useState, Fragment, useCallback } from "react";
import { connect } from "react-redux";
import { set } from "dot-prop-immutable";
import { getActiveElement, getElementWithChildren } from "@whalecloud/page-builder-core/selectors";
import { createTableHeaderCell } from '@whalecloud/page-builder-core/utils/elementUtils';
import { TableEdit, Button } from '@whalecloud/fdx';
import { getLocale, parseTableColumns } from "@utils/util";

const valueKey = 'data.tableSettings';

const ColumnSettingTable = ({ element, ele, updateElement, handleClose }) => {
  console.log('ele: ', ele);
  console.log('parseTableColumns(ele): ', parseTableColumns(ele));
  const messages = getLocale();

  const tarnsformDefaultColumns = (defaultColumns) => {
    return defaultColumns.map(item => {
      return {
        columnSettings: {
          ...item
        }
      }
    })
  };

  const tarnsformHandleRules=(data)=>{
    return data.map(item=>({
      ...item,
      ...(item.required&&item.editType)?{
        editRules:[{required:item.required}]
      }:{},
    }))
  }

  const [colData, setColData] = useState(parseTableColumns(ele));
  const [update, setUpdate] = useState(false);

  const editTypeOptions = [
    { label: '文本框', value: 'text' },
    { label: '下拉框', value: 'select' },
    { label: '复选框', value: 'checkbox' },
    { label: '不可编辑', value: '' },
    { label: '下拉树（单选）', value: 'treeSelect' },
    { label: '下拉树（多选）', value: 'multiTreeSelect' },
    { label: '日期', value: 'date' },
    { label: '时间', value: 'datetime' },
  ];

  const requireOptions=[
    { label:'是',value:true },
    { label:'否',value:false }
  ]

  const columns: any = [
    { title: messages['PAGEBUIDER_SETTINGS_COLUMN_NAME'], dataIndex: "title", editType: "text" },
    { title: messages['PAGEBUIDER_SETTINGS_COLUMN_CODE'], dataIndex: "dataIndex", editType: "text" },
    { title: messages['PAGEBUIDER_SETTINGS_COLUMN_WIDTH'], dataIndex: "width", editType: "text" },
  ];
  if (element.type === 'tableEdit') {
    columns.push({ title: messages['PAGEBUIDER_SETTINGS_COLUMN_TYPE'], dataIndex: "editType", editType: "select", editOptions: editTypeOptions });
    columns.push({ title: messages['PAGEBUIDER_SETTINGS_COLUMN_OPTION'], dataIndex: "editOptions", editType: "text" });
    columns.push({ title: messages['PAGEBUIDER_SETTINGS_COLUMN_REQUIRE'], dataIndex: "required", editType: "select", editOptions: requireOptions });
  }


  const handleOk = () => {
    handleClose();
    if (update) {
      let newElement = set(element, `${valueKey}.columns`, colData);
      updateElement({
        element: newElement
      });

      // 更新表格的 elements, 即 headerCell 数组
      const newColumnsEle = tarnsformDefaultColumns(colData);
      const newElements = newColumnsEle.map(ele => {
        return createTableHeaderCell({ data: ele })
      });
      newElement = set(newElement, 'elements', newElements);
      updateElement({
        element: newElement
      });
    }
  }

  const handleCancel = () => {
    handleClose();
  }

  const onSaveRowEdit = (record, newData) => {
    setColData(tarnsformHandleRules(newData));
    setUpdate(true);
  }

  const afterUpMoveRow = (newData, moveRecord, editingKey) => {
    if (editingKey && moveRecord?.key === editingKey) {
      return;
    }
    setColData(newData);
    setUpdate(true);
  }

  const afterDownMoveRow = (newData, moveRecord, editingKey) => {
    if (editingKey && moveRecord?.key === editingKey) {
      return;
    }
    setColData(newData);
    setUpdate(true);
  }

  const afterRowDelete = newData => {
    setColData(newData);
    setUpdate(true);
  }

  const getScroll = useCallback(
    () => {
      const screenHeight = document.documentElement.clientHeight;
      return { y: screenHeight - 150 };
    }, [element]
  )

  return (
    <Fragment>
      <TableEdit
        dataSource={colData}
        operColumnTitle={messages['PAGEBUIDER_TABLE_OPERATION']}
        insertable
        removeable
        upmoveable
        downmoveable
        onSaveRowEdit={onSaveRowEdit}
        afterRowDelete={afterRowDelete}
        afterUpMoveRow={afterUpMoveRow}
        afterDownMoveRow={afterDownMoveRow}
        scroll={getScroll()}
      >
        {
          columns.map(column => (
            <TableEdit.Column
              key={`table_column_${column.dataIndex}`}
              title={column.title}
              dataIndex={column.dataIndex}
              width={100}
              editType={column.editType}
              editOptions={column.editOptions}
            />
          ))
        }
      </TableEdit>
      <div
        style={{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
        }}
      >
        <Button onClick={handleCancel} style={{ marginRight: 8 }}>
          {messages['PAGEBUIDER_SETTINGS_CANCEL']}
        </Button>
        <Button onClick={handleOk} type="primary">
          {messages['PAGEBUIDER_SETTINGS_CONFIRM']}
        </Button>
      </div>
    </Fragment>
  );
}

export default connect<any, any, any>(state => {
  const element = getActiveElement(state);
  const ele = getElementWithChildren(state, element.id);
  return { element, ele }
})(ColumnSettingTable);
